export default __webpack_public_path__ + "static/media/envelope-square-solid.de826feb.svg";